<template>
	<Primitive
		:as="as"
		class="relative ml-3 whitespace-nowrap before:absolute before:left-[-12px] before:top-1/2 before:size-1 before:-translate-y-1/2 before:bg-beige first:ml-0 first:before:content-none"
	>
		<slot />
	</Primitive>
</template>

<script setup lang="ts">
import type { PrimitiveProps } from 'reka-ui';

import { Primitive } from 'reka-ui';

withDefaults(defineProps<PrimitiveProps>(), {
	as: 'span'
});
</script>
